import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ClientAppLogout } from '../utils/env-setting';

@Injectable({
  providedIn: 'root'
})
export class OAuthErrorInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Check if this is a 400 error from Microsoft OAuth endpoint
        if (error.status === 400 && this.isMicrosoftOAuthError(error.url || request.url)) {
          this.handleOAuthError();
        }
        return throwError(() => error);
      })
    );
  }

  private isMicrosoftOAuthError(url: string): boolean {
    if (!url) return false;
    
    // Check if the URL is a Microsoft OAuth endpoint
    const microsoftOAuthPatterns = [
      'login.microsoftonline.com',
      'oauth2/v2.0/token',
      '/oauth2/', // General OAuth pattern
      '/token' // Token endpoint pattern
    ];
    
    return microsoftOAuthPatterns.some(pattern => url.toLowerCase().includes(pattern.toLowerCase()));
  }

  private handleOAuthError(): void {
    console.warn('OAuth 400 error detected. Clearing local storage and refreshing application...');
    
    try {
      // Clear all local storage session data
      localStorage.clear();
      
      // Also clear session storage if needed
      sessionStorage.clear();
      
      // Use the existing logout function to clear access token
      ClientAppLogout();
      
      // Refresh the application
      globalThis.location.reload();
    } catch (error) {
      console.error('Error during OAuth error handling:', error);
      // Force refresh even if clearing storage fails
      globalThis.location.reload();
    }
  }
}